var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../../core';
import { ICommonState } from '../../../store/CommonState';
import Empty from '../../components/Empty';
import './channel.style.scss';
import ChannelItem from './ChannelItem';
import { Prop } from 'vue-property-decorator';
let RecChannel = class RecChannel extends VueType {
    created() {
        this.state.getModuleListData();
    }
    render() {
        return <div>
            <Empty title={this.title}></Empty>
            <div>
                {this.state.moduleList.map((item, index) => <ChannelItem data={item} index={index}></ChannelItem>)}
            </div>
        </div>;
    }
};
__decorate([
    ICommonState
], RecChannel.prototype, "state", void 0);
__decorate([
    Prop({ default: '你还没有任何观看记录,不如试试这些专属推荐' })
], RecChannel.prototype, "title", void 0);
RecChannel = __decorate([
    Component
], RecChannel);
export default RecChannel;
